import AbstractComponent from './AbstractComponent';

export default class Header extends AbstractComponent {
  /**
   * The HTML element of the header.
   */
  private $header: HTMLElement;

  /**
   * Initializes the header.
   */
  public initialize(): void {
    this.$header = document.querySelector('.header');

    window.addEventListener('scroll', () => this.onScroll());

    this.onScroll();
  }

  private onScroll(): void {
    if (window.scrollY > 0) {
      this.$header.style.backgroundColor = '#ffffff';
    } else {
      this.$header.style.backgroundColor = 'transparent';
    }
  }
}
